<template>
  <div
    class="form fv-plugins-bootstrap5 fv-plugins-framework"
    novalidate="novalidate"
    data-select2-id="select2-data-kt_account_profile_details_form"
  >
    <div
      class="card-body p-9"
      data-select2-id="select2-data-80-y65n"
      v-if="isLoaded"
    >
      <div class="row mb-6" v-if="false">
        <label class="col-lg-4 col-form-label fw-bold fs-6">Avatar</label>
        <div class="col-lg-8">
          <div
            class="image-input image-input-outline"
            data-kt-image-input="true"
            style="background-image: url(assets/media/avatars/blank.png)"
          >
            <div
              class="image-input-wrapper w-125px h-125px"
              style="background-image: url(assets/media/avatars/150-26.jpg)"
            ></div>
            <label
              class="
                btn btn-icon btn-circle btn-active-color-primary
                w-25px
                h-25px
                bg-body
                shadow
              "
              data-kt-image-input-action="change"
              data-bs-toggle="tooltip"
              title=""
              data-bs-original-title="Change avatar"
            >
              <i class="bi bi-pencil-fill fs-7"></i>
              <input type="file" name="avatar" accept=".png, .jpg, .jpeg" />
              <input type="hidden" name="avatar_remove" />
            </label>
            <span
              class="
                btn btn-icon btn-circle btn-active-color-primary
                w-25px
                h-25px
                bg-body
                shadow
              "
              data-kt-image-input-action="cancel"
              data-bs-toggle="tooltip"
              title=""
              data-bs-original-title="Cancel avatar"
            >
              <i class="bi bi-x fs-2"></i>
            </span>
            <span
              class="
                btn btn-icon btn-circle btn-active-color-primary
                w-25px
                h-25px
                bg-body
                shadow
              "
              data-kt-image-input-action="remove"
              data-bs-toggle="tooltip"
              title=""
              data-bs-original-title="Remove avatar"
            >
              <i class="bi bi-x fs-2"></i>
            </span>
          </div>
          <div class="form-text">Allowed file types: png, jpg, jpeg.</div>
        </div>
      </div>
      <div class="row mb-6">
        <label class="col-lg-4 col-form-label fw-bold fs-6">Ad Soyad</label>
        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg-6 fv-row fv-plugins-icon-container">
              <input
                type="text"
                class="
                  form-control form-control-lg form-control-solid
                  mb-3 mb-lg-0
                "
                v-model.trim="user.name"
                placeholder="Ad"
              />
              <div class="fv-plugins-message-container invalid-feedback"></div>
            </div>
            <div class="col-lg-6 fv-row fv-plugins-icon-container">
              <input
                type="text"
                class="form-control form-control-lg form-control-solid"
                v-model.trim="user.surname"
                placeholder="Soyad"
              />
              <div class="fv-plugins-message-container invalid-feedback"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-6">
        <label class="col-lg-4 col-form-label fw-bold fs-6">
          <span class="">E-posta</span>
        </label>
        <div class="col-lg-8 fv-row fv-plugins-icon-container">
          <input
            type="email"
            class="form-control form-control-lg form-control-solid"
            placeholder="E-posta adresiniz"
            v-model.trim="user.email"
          />
          <div class="fv-plugins-message-container invalid-feedback"></div>
        </div>
      </div>
      <div class="row mb-6">
        <label class="col-lg-4 col-form-label fw-bold fs-6"
          >T.C. Kimlik Numarası
        </label>
        <div class="col-lg-8 fv-row">
          <input
            type="text"
            class="form-control form-control-lg form-control-solid"
            placeholder="T.C. Kimlik Numaranız"
            v-model.trim="user.tc"
            v-numeric="true"
            maxlength="11"
          />
        </div>
      </div>
      <div class="row mb-0">
        <label class="col-lg-4 col-form-label fw-bold fs-6"
          >Kronik bir hastalığınız var mı?</label
        >
        <div class="col-lg-8 d-flex align-items-center">
          <div class="form-check form-check-solid form-switch fv-row">
            <input
              class="form-check-input w-45px h-30px"
              type="checkbox"
              v-model.trim="user.kronik"
            />
            <label class="form-check-label" for="allowmarketing"></label>
          </div>
        </div>
      </div>
      <transition name="fade" mode="out-in">
        <div class="row mb-6" v-if="user.kronik">
          <label class="col-lg-4 col-form-label fw-bold fs-6">
            <span class="">Kronik hastalığınız</span>
          </label>
          <div class="col-lg-8 fv-row fv-plugins-icon-container">
            <input
              type="text"
              class="form-control form-control-lg form-control-solid"
              placeholder="Kronik hastalığınız"
              v-model.trim="user.kronik_cevap"
            />
            <div class="fv-plugins-message-container invalid-feedback"></div>
          </div>
        </div>
      </transition>
      <div class="row mb-0">
        <label class="col-lg-4 col-form-label fw-bold fs-6"
          >Daha önce psikolojik tedavi ya da ilaç tedavisi aldınız mı?</label
        >
        <div class="col-lg-8 d-flex align-items-center">
          <div class="form-check form-check-solid form-switch fv-row">
            <input
              class="form-check-input w-45px h-30px"
              type="checkbox"
              v-model.trim="user.ilac"
            />
            <label class="form-check-label" for="allowmarketing"></label>
          </div>
        </div>
      </div>
      <transition name="fade" mode="out-in">
        <div class="row mb-6" v-if="user.ilac">
          <label class="col-lg-4 col-form-label fw-bold fs-6">
            <span class=""
              >Daha önce aldığınız psikolojik tedaviniz ya da ilaç
              tedaviniz</span
            >
          </label>
          <div class="col-lg-8 fv-row fv-plugins-icon-container">
            <input
              type="text"
              class="form-control form-control-lg form-control-solid"
              placeholder="Kronik hastalığınız"
              v-model.trim="user.ilac_cevap"
            />
            <div class="fv-plugins-message-container invalid-feedback"></div>
          </div>
        </div>
      </transition>
      <div class="row mb-0">
        <label class="col-lg-4 col-form-label fw-bold fs-6"
          >Kendinize ya da çevrenize zarar verme eğiliminiz var mı?</label
        >
        <div class="col-lg-8 d-flex align-items-center">
          <div class="form-check form-check-solid form-switch fv-row">
            <input
              class="form-check-input w-45px h-30px"
              type="checkbox"
              v-model.trim="user.suicide"
            />
            <label class="form-check-label" for="allowmarketing"></label>
          </div>
        </div>
      </div>
      <div class="row mb-0">
        <label class="col-lg-4 col-form-label fw-bold fs-6"
          >Alkol kullanıyor musunuz?</label
        >
        <div class="col-lg-8 d-flex align-items-center">
          <div class="form-check form-check-solid form-switch fv-row">
            <input
              class="form-check-input w-45px h-30px"
              type="checkbox"
              v-model.trim="user.alkol"
            />
            <label class="form-check-label" for="allowmarketing"></label>
          </div>
        </div>
      </div>
      <div class="row mb-0">
        <label class="col-lg-4 col-form-label fw-bold fs-6"
          >Gerekli olduğunda yüz yüze görüşmek isterim</label
        >
        <div class="col-lg-8 d-flex align-items-center">
          <div class="form-check form-check-solid form-switch fv-row">
            <input
              class="form-check-input w-45px h-30px"
              type="checkbox"
              v-model.trim="user.requiredMeeting"
            />
            <label class="form-check-label" for="allowmarketing"></label>
          </div>
        </div>
      </div>
      <div class="row mb-6">
        <label class="col-lg-4 col-form-label fw-bold fs-6"
          >Acil durumlarda aranacak kişinin isim ve soyismi</label
        >
        <div class="col-lg-8 fv-row fv-plugins-icon-container">
          <input
            type="text"
            class="form-control form-control-lg form-control-solid"
            v-model.trim="user.emergencyContact"
          />
          <div class="fv-plugins-message-container invalid-feedback"></div>
        </div>
      </div>
      <div class="row mb-6">
        <label class="col-lg-4 col-form-label fw-bold fs-6"
          >Acil durumlarda aranacak kişinin telefon numarası</label
        >
        <div class="col-lg-8 fv-row fv-plugins-icon-container">
          <input
            type="text"
            class="form-control form-control-lg form-control-solid"
            v-model.trim="user.emergencyContactNumber"
          />
          <div class="fv-plugins-message-container invalid-feedback"></div>
        </div>
      </div>
      <div class="row mb-6">
        <label class="col-lg-4 col-form-label fw-bold fs-6"
          >Başvuru nedenizi belirtiniz</label
        >
        <div class="col-lg-8 fv-row fv-plugins-icon-container">
          <input
            type="text"
            class="form-control form-control-lg form-control-solid"
            v-model.trim="user.problem"
          />
          <div class="fv-plugins-message-container invalid-feedback"></div>
        </div>
      </div>
      <div class="row mb-6" style="margin-bottom: 0 !important">
        <label class="col-lg-4 col-form-label fw-bold fs-6"
          >Belirtmek istediğiniz özel durumlar</label
        >
        <div class="col-lg-8 fv-row fv-plugins-icon-container">
          <textarea
            class="form-control form-control-solid mb-8"
            v-model.trim="user.conditions"
            rows="3"
          ></textarea>

          <div class="fv-plugins-message-container invalid-feedback"></div>
        </div>
      </div>
    </div>
    <div class="card-footer d-flex justify-content-end py-6 px-9">
      <button
        type="reset"
        class="btn btn-light btn-active-light-primary me-2"
        @click="back"
      >
        İptal
      </button>
      <button
        type="submit"
        class="btn btn-primary btn-active"
        :class="{ '-invalid': !tcknValid }"
        @click="updateUserInfo"
      >
        Değişiklikleri Kaydet
      </button>
    </div>
    <input type="hidden" />
    <div></div>
  </div>
</template>

<script>
import * as API from "@/services/";
import { numeric } from "@/directives/";
export default {
  data() {
    return {
      isLoaded: false,
      token: this.$store.getters.getAccessToken,
      user: {
        phone: null,
        tc: null,
      },
    };
  },
  async created() {
    this.getUserInfo();
  },
  computed: {
    phoneValid: function () {
      if (!this.user.phone || this.user.phone.toString().length != 10)
        return false;
      return true;
    },
    tcknValid: function () {
      if (!this.user.tc || this.user.tc.toString().length != 11) return false;
      return true;
    },
  },
  directives: { numeric },
  methods: {
    getUserInfo: async function () {
      let vm = this;

      if (!vm.token) return;

      let response = await API.getUserInfo(vm.token);

      if (response.status == "fail")
        return vm.$store.dispatch("logout").then(() => location.reload());

      vm.user = {
        ...response.data,
        kronik: response.data.kronik == "Evet",
        ilac: response.data.ilac == "Evet",
        suicide: response.data.suicide == "Evet",
        alkol: response.data.alkol == "Evet",
        requiredMeeting: response.data.requiredMeeting == "Evet",
      };

      return (vm.isLoaded = true);
    },
    updateUserInfo: async function () {
      let vm = this;

      if (!vm.tcknValid) return;

      let form = {
        token: vm.token,
        type: vm.user.type,
        today: vm.user.today,
        suicide: vm.user.suicide ? "Evet" : "Hayır",
        suicideForm: vm.user.suicideForm,
        address: vm.user.address,
        tc: vm.user.tc,
        taxNumber: vm.user.taxNumber,
        taxOffice: vm.user.taxOffice,
        companyName: vm.user.companyName,
        iban: vm.user.iban,
        about: vm.user.about,
        title: vm.user.title,
        name: vm.user.name,
        surname: vm.user.surname,
        email: vm.user.email,
        gender: vm.user.gender,
        age: vm.user.age,
        kronik: vm.user.kronik ? "Evet" : "Hayır",
        kronik_cevap: vm.user.kronik_cevap,
        ilac: vm.user.ilac ? "Evet" : "Hayır",
        ilac_cevap: vm.user.ilac_cevap,
        alkol: vm.user.alkol ? "Evet" : "Hayır",
        requiredMeeting: vm.user.requiredMeeting ? "Evet" : "Hayır",
        emergencyContact: vm.user.emergencyContact,
        emergencyContactNumber: vm.user.emergencyContactNumber,
        problem: vm.user.problem,
        conditions: vm.user.conditions,
      };

      let response = await API.updateUserInfo(form);
      console.log("response >>", response);

      return;
    },
    makeDate: function (date) {
      let d = new Date(date);

      let months = [
        "Ocak",
        "Şubat",
        "Mart",
        "Nisan",
        "Mayıs",
        "Haziran",
        "Temmuz",
        "Ağustos",
        "Eylül",
        "Ekim",
        "Kasım",
        "Aralık",
      ];

      let day = d.getDate();
      let month = d.getMonth();
      let year = d.getFullYear();

      let _date = `${day < 10 ? "0" + day : day} ${months[month]} ${year}`;

      return _date;
    },
    back: function () {
      this.$router.go(-1);
    },
  },
};
</script>